import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../components/login.vue')
  },
  {
    path: '/principal',
    name: 'principal',
    component: () => import(/* webpackChunkName: "about" */ '../components/principal.vue'),
    meta: { requiresAuth: true }
  },
  ,
  {
    path: '/archivoCompartido',
    name: 'archivoCompartido',
    component: () => import(/* webpackChunkName: "about" */ '../components/archivoCompartido.vue'),
  },
  {
    path: '/principalUsuarios',
    name: 'principalUsuarios',
    component: () => import(/* webpackChunkName: "about" */ '../components/principalUsuarios.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/gestionUsuario/:correo',
    name: 'gestionUsuario',
    component: () => import(/* webpackChunkName: "about" */ '../components/gestionUsuarios.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/gestionGrupoAccesos/:id',
    name: 'gestionGrupoAccesos',
    component: () => import(/* webpackChunkName: "about" */ '../components/gestionGrupoAccesos.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/nuevoUsuario',
    name: 'nuevoUsuario',
    component: () => import(/* webpackChunkName: "about" */ '../components/nuevoUsuario.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/nuevoGrupoAccesos',
    name: 'nuevoGrupoAccesos',
    component: () => import(/* webpackChunkName: "about" */ '../components/nuevoGrupoAccesos.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/recuperarContrasena',
    name: 'recuperarContrasena',
    component: () => import(/* webpackChunkName: "about" */ '../components/recuperarContrasena.vue'),
  },
  {
    path: '/sucesosRegistradosUsuario/:correo',
    name: 'sucesusUsuario',
    component: () => import(/* webpackChunkName: "about" */ '../components/sucesusUsuario.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/sucesosGlobales',
    name: 'sucesosGlobales',
    component: () => import(/* webpackChunkName: "about" */ '../components/sucesosGlobales.vue'),
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {

  let acceso = false
  if (to.matched.some(route => route.meta.requiresAuth)) {
    if (localStorage.token) {
      acceso = true;
    }
  } else if(to.name == 'login' || to.name == 'recuperarContrasena' || to.name == 'archivoCompartido'){
      acceso = true
  }

  if(to.name == 'login' && localStorage.token != null){
    return next({ path: '/principal' })
  }
  if (!acceso) {
    next({ path: '/' })
  } else {
    next()
  }
})

export default router
